import { brgChipColorMapper, } from '@/components/Common/Chip.vue';
import { reportTypeOptionMapper, } from '@/types/entity/IHubAdjustmentDaily';
import { i18n } from '@/locales';
const lc = 'views.hub_adjustment_daily.';
const orderMetricsDailyConditionType = [
    'ORDER_STORE',
    'ORDER_HUB',
    'AGENCY_HUB',
];
const hubAdjustmentDailySearchOptionList = orderMetricsDailyConditionType.map((code) => ({
    text: i18n.t(`${lc}${code.toLowerCase()}`),
    value: code,
}));
const hubDailyReportPageConfigMapper = {
    // 일별 매출 / 배달대행료 B2B
    [reportTypeOptionMapper.B2B_DELIVERY_CHARGE]: {
        title: i18n.t('views.hub_adjustment.b2b_delivery_charge'),
        chipInfo: {
            color: brgChipColorMapper.blue,
            text: i18n.t('views.hub_adjustment.B2B'),
        },
        storeType: 'B2B',
    },
    // 일별 매출 / 배달대행료 로드샵(본사계약) 배달대행료는 동일 결과 필터링.
    [reportTypeOptionMapper.ROAD_SHOP_DELIVERY_CHARGE]: {
        title: i18n.t('views.hub_adjustment.road_shop_delivery_charge'),
        chipInfo: {
            color: brgChipColorMapper.green,
            text: i18n.t('views.hub_adjustment.head_office_contract_store'),
        },
        storeType: 'GENERAL',
    },
    // 일별 매출 / 배달대행료 / 상세 정보 B2B
    [reportTypeOptionMapper.B2B_DELIVERY_CHARGE_DETAIL]: {
        title: '',
        storeType: 'B2B',
    },
    // 일별 매출 / 배달대행료 / 상세 정보 로드샵(본사계약)
    [reportTypeOptionMapper.ROAD_SHOP_DELIVERY_CHARGE_DETAIL]: {
        title: '',
        storeType: 'GENERAL',
    },
    // 일별 매출 / 상점 수수료
    [reportTypeOptionMapper.STORE_FEE]: {
        title: i18n.t('views.hub_adjustment.store_fee'),
        chipInfo: {
            color: brgChipColorMapper.green,
            text: i18n.t('views.hub_adjustment.head_office_contract_store'),
        },
    },
    // 일별 매출 / 상점 수수료 / 상세 정보(storeFee)
    [reportTypeOptionMapper.STORE_FEE_DETAIL]: {
        title: '',
    },
    // 일별 매출 / 상점 관리비
    [reportTypeOptionMapper.STORE_MANAGEMENT_FEE]: {
        title: i18n.t('views.hub_adjustment.store_management_fee'),
        chipInfo: {
            color: brgChipColorMapper.green,
            text: i18n.t('views.hub_adjustment.head_office_contract_store'),
        },
    },
    // 일별 매출 / 허브 수수료 발주총판 수익(hubFee) - 상점수수료 상세정보와 동일 api
    [reportTypeOptionMapper.SALES_ORDER_DISTRIBUTOR_HUB_FEE]: {
        title: i18n.t('views.hub_adjustment.sales_order_distributor_hub_fee'),
    },
    // 매입 / 허브
    [reportTypeOptionMapper.PURCHASE_HUB_FEE]: {
        title: i18n.t('views.hub_adjustment.hub_fee'),
        chipInfo: {
            color: 'blueGrey',
            text: i18n.t('views.hub_adjustment.head_office_not_contract_store'),
        },
        storeType: 'GENERAL',
    },
    // 매입 / 상점
    [reportTypeOptionMapper.PURCHASE_STORE_MANAGEMENT_FEE]: {
        title: i18n.t('views.hub_adjustment.store_management_fee'),
        chipInfo: {
            color: 'blueGrey',
            text: i18n.t('views.hub_adjustment.head_office_not_contract_store'),
        },
    },
};
const hubDailyReportApiEndPointMapper = {
    // 일별 매출 / 배달대행료 B2B
    [reportTypeOptionMapper.B2B_DELIVERY_CHARGE]: 'sales-purchase/delivery-charge',
    // 일별 매출 / 배달대행료 로드샵(본사계약) 배달대행료는 동일 결과 필터링.
    [reportTypeOptionMapper.ROAD_SHOP_DELIVERY_CHARGE]: 'sales-purchase/delivery-charge',
    // 일별 매출 / 배달대행료 / 상세 정보 B2B
    [reportTypeOptionMapper.B2B_DELIVERY_CHARGE_DETAIL]: 'sales-purchase/delivery-charge-detail',
    // 일별 매출 / 배달대행료 / 상세 정보 로드샵(본사계약)
    [reportTypeOptionMapper.ROAD_SHOP_DELIVERY_CHARGE_DETAIL]: 'sales-purchase/delivery-charge-detail',
    // 일별 매출 / 상점 수수료
    [reportTypeOptionMapper.STORE_FEE]: 'sales/store-fee',
    // 일별 매출 / 상점 수수료 / 상세 정보(storeFee)
    [reportTypeOptionMapper.STORE_FEE_DETAIL]: 'sales/store-fee-detail',
    // 일별 매출 / 상점 관리비
    [reportTypeOptionMapper.STORE_MANAGEMENT_FEE]: 'sales-purchase/store-management-fee',
    // 일별 매출 / 허브 수수료 발주총판 수익(hubFee) - 상점수수료 상세정보와 동일 api 분리시 이것만 수정하면 됨
    [reportTypeOptionMapper.SALES_ORDER_DISTRIBUTOR_HUB_FEE]: 'sales/order-distributor-hub-fee',
    // 매입 / 허브
    [reportTypeOptionMapper.PURCHASE_HUB_FEE]: 'purchase/hub-fee',
    // 매입 / 상점
    [reportTypeOptionMapper.PURCHASE_STORE_MANAGEMENT_FEE]: 'purchase/store-management-fee',
};
const hubDailyReportTableOptionTypeMapper = {
    // 일별 매출 / 배달대행료 B2B
    [reportTypeOptionMapper.B2B_DELIVERY_CHARGE]: [
        {
            title: i18n.t(`${lc}sales.delivery_charge.order_owner_type`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreType',
            origin: 'storeType',
            width: 74,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.date`),
            align: 'center',
            sortable: true,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.order_completed_count`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderCompletedCount',
            origin: 'orderCompletedCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.revenue_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedRevenueCharge',
            origin: 'revenueCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.deduction_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeductionCharge',
            origin: 'deductionCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.delivery_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryCharge',
            origin: 'deliveryCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.delivery_charge_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryChargeTax',
            origin: 'deliveryChargeTax',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.delivery_total_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryTotalCharge',
            origin: 'deliveryTotalCharge',
            width: 180,
            total: true,
        },
    ],
    // 일별 매출 / 배달대행료 로드샵(본사계약)
    [reportTypeOptionMapper.ROAD_SHOP_DELIVERY_CHARGE]: [
        {
            title: i18n.t(`${lc}sales.delivery_charge.order_owner_type`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreType',
            origin: 'storeType',
            width: 74,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.date`),
            align: 'center',
            sortable: true,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.order_completed_count`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderCompletedCount',
            origin: 'orderCompletedCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.revenue_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedRevenueCharge',
            origin: 'revenueCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.deduction_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeductionCharge',
            origin: 'deductionCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.delivery_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryCharge',
            origin: 'deliveryCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.delivery_charge_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryChargeTax',
            origin: 'deliveryChargeTax',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge.delivery_total_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryTotalCharge',
            origin: 'deliveryTotalCharge',
            width: 180,
            total: true,
        },
    ],
    // 일별 매출 / 배달대행료 / 상세 정보 B2B
    [reportTypeOptionMapper.B2B_DELIVERY_CHARGE_DETAIL]: [
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_owner_type`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreType',
            origin: 'storeType',
            width: 74,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.date`),
            align: 'center',
            sortable: false,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_date`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderDate',
            origin: 'orderDate',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_distributor_id`),
            origin: 'orderDistributorId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_hub_id`),
            origin: 'orderHubId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_hub_name`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderHubName',
            origin: 'orderHubName',
            width: 176,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.store_id`),
            origin: 'storeId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.store_name`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreName',
            origin: 'storeName',
            width: 220,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.agency_hub_name`),
            align: 'center',
            sortable: false,
            value: 'formattedAgencyHubName',
            origin: 'agencyHubName',
            width: 176,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_completed_count`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderCompletedCount',
            origin: 'orderCompletedCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.agency_distributor_id`),
            origin: 'agencyDistributorId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.agency_hub_id`),
            origin: 'agencyHubId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.worker_delivery_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedWorkerDeliveryCharge',
            origin: 'workerDeliveryCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.worker_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedWorkerFee',
            origin: 'workerFee',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.pre_deduct_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedPreDeductCharge',
            origin: 'preDeductCharge',
            width: 112,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.hub_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedHubFee',
            origin: 'hubFee',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.hub_adjustment_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedHubAdjustmentFee',
            origin: 'hubAdjustmentFee',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.delivery_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryCharge',
            origin: 'deliveryCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.delivery_charge_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryChargeTax',
            origin: 'deliveryChargeTax',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.delivery_total_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryTotalCharge',
            origin: 'deliveryTotalCharge',
            width: 180,
            total: true,
        },
    ],
    // 일별 매출 / 배달대행료 / 상세 정보 B2B
    [reportTypeOptionMapper.ROAD_SHOP_DELIVERY_CHARGE_DETAIL]: [
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_owner_type`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreType',
            origin: 'storeType',
            width: 74,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.date`),
            align: 'center',
            sortable: false,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_date`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderDate',
            origin: 'orderDate',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_distributor_id`),
            origin: 'orderDistributorId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_hub_id`),
            origin: 'orderHubId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_hub_name`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderHubName',
            origin: 'orderHubName',
            width: 176,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.store_id`),
            origin: 'storeId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.store_name`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreName',
            origin: 'storeName',
            width: 220,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.is_adjustment_by_head_office`),
            align: 'center',
            sortable: false,
            value: 'formattedIsAdjustmentByHeadOffice',
            origin: 'isAdjustmentByHeadOffice',
            width: 78,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.agency_hub_name`),
            align: 'center',
            sortable: false,
            value: 'formattedAgencyHubName',
            origin: 'agencyHubName',
            width: 176,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_completed_count`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderCompletedCount',
            origin: 'orderCompletedCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.agency_distributor_id`),
            origin: 'agencyDistributorId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.agency_hub_id`),
            origin: 'agencyHubId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.worker_delivery_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedWorkerDeliveryCharge',
            origin: 'workerDeliveryCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.worker_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedWorkerFee',
            origin: 'workerFee',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.pre_deduct_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedPreDeductCharge',
            origin: 'preDeductCharge',
            width: 112,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.hub_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedHubFee',
            origin: 'hubFee',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.hub_adjustment_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedHubAdjustmentFee',
            origin: 'hubAdjustmentFee',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.delivery_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryCharge',
            origin: 'deliveryCharge',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.delivery_charge_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryChargeTax',
            origin: 'deliveryChargeTax',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.delivery_total_charge`),
            align: 'center',
            sortable: false,
            value: 'formattedDeliveryTotalCharge',
            origin: 'deliveryTotalCharge',
            width: 180,
            total: true,
        },
    ],
    // 일별 매출 / 상점 수수료
    [reportTypeOptionMapper.STORE_FEE]: [
        {
            title: i18n.t(`${lc}sales.delivery_fee.date`),
            align: 'center',
            sortable: true,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee.order_completed_count`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderCompletedCount',
            origin: 'orderCompletedCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee.store_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreFee',
            origin: 'storeFee',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee.store_fee_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreFeeTax',
            origin: 'storeFeeTax',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee.store_total_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreTotalFee',
            origin: 'storeTotalFee',
            width: 180,
            total: true,
        },
    ],
    // 일별 매출 / 상점 수수료 / 상세 정보(storeFee)
    [reportTypeOptionMapper.STORE_FEE_DETAIL]: [
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.date`),
            align: 'center',
            sortable: false,
            value: 'formattedDate',
            origin: 'date',
            width: 74,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.order_date`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderDate',
            origin: 'orderDate',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_hub_id`),
            origin: 'orderHubId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.order_hub_name`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderHubName',
            origin: 'orderHubName',
            width: 150,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.store_id`),
            origin: 'storeId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.store_name`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreName',
            origin: 'storeName',
            width: 450,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.is_adjustment_by_head_office`),
            align: 'center',
            sortable: false,
            value: 'formattedIsAdjustmentByHeadOffice',
            origin: 'isAdjustmentByHeadOffice',
            width: 78,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.order_completed_count`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderCompletedCount',
            origin: 'orderCompletedCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.store_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreFee',
            origin: 'storeFee',
            width: 200,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.store_fee_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreFeeTax',
            origin: 'storeFeeTax',
            width: 200,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.delivery_fee_detail.store_total_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreTotalFee',
            origin: 'storeTotalFee',
            width: 200,
            total: true,
        },
    ],
    // 일별 매출 / 상점 관리비
    [reportTypeOptionMapper.STORE_MANAGEMENT_FEE]: [
        {
            title: i18n.t(`${lc}sales.store_management_fee.date`),
            align: 'center',
            sortable: true,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.transaction_date`),
            align: 'center',
            sortable: false,
            value: 'formattedTransactionDate',
            origin: 'transactionDate',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.store_id`),
            origin: 'storeId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.store_name`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreName',
            origin: 'storeName',
            width: 410,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.is_adjustment_by_head_office`),
            align: 'center',
            sortable: false,
            value: 'formattedIsAdjustmentByHeadOffice',
            origin: 'isAdjustmentByHeadOffice',
            width: 78,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.store_management_deposit_withdrawal_count`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreManagementDepositWithdrawalCount',
            origin: 'storeManagementDepositWithdrawalCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.sales_management_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedSalesManagementFee',
            origin: 'salesManagementFee',
            width: 160,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.purchase_management_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedPurchaseManagementFee',
            origin: 'purchaseManagementFee',
            width: 160,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.store_management_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreManagementFee',
            origin: 'storeManagementFee',
            width: 160,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.store_management_fee_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreManagementFeeTax',
            origin: 'storeManagementFeeTax',
            width: 160,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.store_management_fee.store_management_total_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreManagementTotalFee',
            origin: 'storeManagementTotalFee',
            width: 160,
            total: true,
        },
    ],
    // 일별 매출 / 허브 수수료 발주총판 수익(hubFee)
    [reportTypeOptionMapper.SALES_ORDER_DISTRIBUTOR_HUB_FEE]: [
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.date`),
            align: 'center',
            sortable: true,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.order_date`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderDate',
            origin: 'orderDate',
            width: 84,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.order_hub_id`),
            origin: 'orderHubId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.order_hub_name`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderHubName',
            origin: 'orderHubName',
            width: 176,
        },
        {
            title: i18n.t(`${lc}sales.delivery_charge_detail.store_id`),
            origin: 'storeId',
            downloadOnly: true,
        },
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.store_name`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreName',
            origin: 'storeName',
            width: 410,
        },
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.is_adjustment_by_head_office`),
            align: 'center',
            sortable: false,
            value: 'formattedIsAdjustmentByHeadOffice',
            origin: 'isAdjustmentByHeadOffice',
            width: 78,
        },
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.order_completed_count`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderCompletedCount',
            origin: 'orderCompletedCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.order_distributor_hub_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedDistributorHubFee',
            origin: 'distributorHubFee',
            width: 220,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.order_distributor_hub_fee_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedDistributorHubFeeTax',
            origin: 'distributorHubFeeTax',
            width: 220,
            total: true,
        },
        {
            title: i18n.t(`${lc}sales.sales_order_distributor_hub_fee.order_distributor_hub_total_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedDistributorHubTotalFee',
            origin: 'distributorHubTotalFee',
            width: 220,
            total: true,
        },
    ],
    // 매입 / 허브
    [reportTypeOptionMapper.PURCHASE_HUB_FEE]: [
        {
            title: i18n.t(`${lc}purchase.hub_fee.order_owner_type`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreType',
            origin: 'storeType',
            width: 74,
        },
        {
            title: i18n.t(`${lc}purchase.hub_fee.date`),
            align: 'center',
            sortable: true,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}purchase.hub_fee.order_date`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderDate',
            origin: 'orderDate',
            width: 84,
        },
        {
            title: i18n.t(`${lc}purchase.hub_fee.is_adjustment_by_head_office`),
            align: 'center',
            sortable: false,
            value: 'formattedIsAdjustmentByHeadOffice',
            origin: 'isAdjustmentByHeadOffice',
            width: 78,
        },
        {
            title: i18n.t(`${lc}purchase.hub_fee.order_completed_count`),
            align: 'center',
            sortable: false,
            value: 'formattedOrderCompletedCount',
            origin: 'orderCompletedCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}purchase.hub_fee.hub_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedHubFee',
            origin: 'hubFee',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}purchase.hub_fee.hub_fee_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedHubFeeTax',
            origin: 'hubFeeTax',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}purchase.hub_fee.hub_total_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedHubTotalFee',
            origin: 'hubTotalFee',
            width: 180,
            total: true,
        },
    ],
    // 매입 / 상점
    [reportTypeOptionMapper.PURCHASE_STORE_MANAGEMENT_FEE]: [
        {
            title: i18n.t(`${lc}purchase.store_management_fee.date`),
            align: 'center',
            sortable: true,
            value: 'formattedDate',
            origin: 'date',
            width: 84,
        },
        {
            title: i18n.t(`${lc}purchase.store_management_fee.transaction_date`),
            align: 'center',
            sortable: false,
            value: 'formattedTransactionDate',
            origin: 'transactionDate',
            width: 84,
        },
        {
            title: i18n.t(`${lc}purchase.store_management_fee.store_management_deposit_withdrawal_count`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreManagementDepositWithdrawalCount',
            origin: 'storeManagementDepositWithdrawalCount',
            width: 150,
            total: true,
        },
        {
            title: i18n.t(`${lc}purchase.store_management_fee.store_management_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreManagementFee',
            origin: 'storeManagementFee',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}purchase.store_management_fee.store_management_fee_tax`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreManagementFeeTax',
            origin: 'storeManagementFeeTax',
            width: 180,
            total: true,
        },
        {
            title: i18n.t(`${lc}purchase.store_management_fee.store_management_total_fee`),
            align: 'center',
            sortable: false,
            value: 'formattedStoreManagementTotalFee',
            origin: 'storeManagementTotalFee',
            width: 180,
            total: true,
        },
    ],
};
export { hubAdjustmentDailySearchOptionList, hubDailyReportPageConfigMapper, hubDailyReportTableOptionTypeMapper, hubDailyReportApiEndPointMapper, };
